import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function applicationListQueryOptions(params: ListParams) {
  return queryOptions({
    queryKey: applicationKeys.list(params),
    queryFn: () => applicationsApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useApplications(params: ListParams) {
  return useQuery(applicationListQueryOptions(params));
}
